var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImagePlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 181.67 126.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-1,.cls-2{stroke:#231f20;stroke-miterlimit:10;stroke-width:7px;}.cls-2{fill:#231f20;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M164,123.17H17.67A14.18,14.18,0,0,1,3.5,109V17.67a14.47,14.47,0,0,1,4.15-10,14.16,14.16,0,0,1,10-4.15H164a14.18,14.18,0,0,1,14.18,14.17V109A14.18,14.18,0,0,1,164,123.17Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 38.17,
    cy: 37.5,
    r: 9.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.83,120.17A232.61,232.61,0,0,1,24.67,99.11C44.26,78.59,56.29,66,69,67c20.57,1.63,27,37.63,39.67,35.45,13.53-2.34,17.44-45.68,33.33-48.34a12.43,12.43,0,0,1,2.83-.11c7,.68,10.73,8.37,18.5,22.33,11,19.84,14,21.54,13.5,28.17-.49,7.07-4.27,12.52-7.16,15.83"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePlaceholder);
export default __webpack_public_path__ + "static/media/imagePlaceholder.dcad7f1ddfacc7f91694e552d80206b9.svg";
export { ForwardRef as ReactComponent };